module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"NOTFOUND":"Not Found","LOST":"Looks like you\u0027ve got lost...","NOTEXIST":"The page you\u0027re looking for doesn\u0027t exist or has been moved.","GOHOME":"Go Home"},"ar":{"NOTFOUND":"غير معثور عليه","LOST":"يبدو أنك قد ضاعت...","NOTEXIST":"الصفحة التي تبحث عنها غير موجودة أو تم نقلها.","GOHOME":"اذهب للمنزل"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/404.vue
// module id = 295
// module chunks = 1